import { GzzTelephone } from "../general/GzzTelephone";
import { GzzAddress } from "../general/GzzAddress";
import { GzzBankAccount } from "../general/GzzBankAccount";

export class SrvClaimer {

  FirstName: string;
  LastName: string;
  IDNumber: string;
  Email: string;
  PhoneNumber: GzzTelephone;
  MobileNumber: GzzTelephone;
  Closeness: number;
  HadRemarried: boolean;
  Address: GzzAddress;
  BankAccountDetails: GzzBankAccount;

  constructor(data: SrvClaimer) {

    Object.assign(this, data);

    if (data) {

      if (data.PhoneNumber) {
        this.PhoneNumber = new GzzTelephone(data.PhoneNumber);
      }
      if (data.MobileNumber) {
        this.MobileNumber = new GzzTelephone(data.MobileNumber);
      }
      if (data.Address) {
        this.Address = new GzzAddress(data.Address);
      }
      if (data.BankAccountDetails) {
        this.BankAccountDetails = new GzzBankAccount(data.BankAccountDetails);
      }
      if (data.Closeness)
        this.Closeness = data.Closeness['Code'];
    }
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/Survivors/SrvClaimer.ts